<template>
	<div
		class="fixed z-10 inset-0 overflow-y-auto"
		aria-labelledby="modal-title"
		role="dialog"
		aria-modal="true"
	>
		<div
			class="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0"
		>
			<transition name="fade">
				<div
					class="fixed inset-0 bg-gray-700 bg-opacity-75 transition-opacity"
					aria-hidden="true"
					v-if="open"
					ref="overlay"
					v-on:click="close()"
				></div>
			</transition>

			<!-- This element is to trick the browser into centering the modal contents. -->
			<span
				class="hidden sm:inline-block sm:align-middle sm:h-screen"
				aria-hidden="true"
				>&#8203;</span
			>

			<transition name="zoomin">
				<div
					class="inline-block align-middle bg-white rounded-2xl text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full md:max-w-screen-md"
				>
					<slot name="full-content">
						<div class="bg-green-500 px-6 py-4 text-white">
							<div class="flex justify-between items-baseline pr-4 mr-6">
								<h2 class="text-4xl font-bold">
									{{ __("Prüfen und Menge bereitstellen") }}
								</h2>
							</div>

							<ui-button
								type="blank"
								class="absolute right-5 top-5"
								v-on:click="close()"
							>
								<ui-icon class="h-9 w-9 text-white" name="x" stroke-width="2" />
							</ui-button>
						</div>
						<div class="p-6">
							<my-lots-auction-offer-summary
								:offer="offer"
							></my-lots-auction-offer-summary>

							<div class="grid grid-cols-3 border-t border-gray-200 pt-2">
								<h4 class="text-gray-900 text-xl font-semibold hyphens">
									{{ __("Menge für Auktion") }}
								</h4>
								<p class="text-gray-900 text-xl font-semibold col-span-2">
									<span v-html="form.auction.qty_mt" /> t<span class="text-sm"
										>, ca.</span
									>
								</p>
							</div>

							<div
								class="grid grid-cols-3 border-t border-b border-gray-200 pt-2"
							>
								<h4 class="text-sm text-gray-900 text-xl font-semibold hyphens">
									{{ __("Ihr Zielpreis") }}
								</h4>
								<p
									class="text-sm text-gray-900 text-xl font-semibold col-span-2"
								>
									<span v-html="form.auction.price" />
									<span class="text-sm">&euro;/t</span>
								</p>
							</div>

							<div class="grid grid-cols-3 border-t border-gray-200 pt-2">
								<h4 class="text-sm text-gray-900 hyphens">
									{{ __("Zeitraum Auktion") }}
								</h4>
								<p class="text-sm col-span-2">
									{{ auctionDate }} {{ __("von") }} {{ auctionTimeStart }}
									{{ __("bis") }} {{ auctionTimeEnd }} {{ __("(MEZ)") }}
								</p>
							</div>

							<div class="sm:flex sm:items-start my-5">
								<!--div class="bg-red-500 rounded-lg text-white text-xxl mt-4 mx-2 p-2">
                                    !
                                </div-->
								<ui-icon
									name="alert-triangle"
									class="h-14 w-14 mx-2 text-red-400"
									aria-hidden="true"
								/>
								<div class="font-medium bg-red-200 text-gray-900 py-2 px-1">
									{{
										__(
											"Achtung! Wenn ein Händler mindestens den von Ihnen gewünschten Preis auf Ihre Menge biete, kommt am Ende der Auktion automatisch ein Kontrakt zustande."
										)
									}}
								</div>
							</div>

							<div class="font-medium text-green-500 my-5">
								{{
									__(
										"Bei Abschluss dieses Kontrakts wird Ihnen eine Kommission in Höhe von 1,00 € pro Tonne in Rechnung gestellt."
									)
								}}
							</div>
						</div>
						<div class="bg-gray-100 px-6 pt-4 pb-6">
							<div class="flex justify-end">
								<div class="sm:flex sm:items-start mt-4">
									<div class="text-center sm:mt-0 sm:ml-4 sm:text-left">
										<ui-button v-on:click="submit()">{{
											__("Auktionsmenge bereitstellen")
										}}</ui-button>
									</div>
								</div>
							</div>
						</div>
					</slot>
				</div>
			</transition>
		</div>
	</div>
</template>

<script>
let options = require("../../cropOptions.js");
function padTo2Digits(num) {
	return num.toString().padStart(2, "0");
}
export default {
	props: {
		offer: {
			type: Object,
			required: true,
		},
		form: {
			type: Object,
			required: true,
		},
		showAuctionSubmittedModal: {
			type: Boolean,
			required: true,
		},
		auction: {
			type: Object,
			required: false,
			default: null,
		},
	},
	data() {
		return {
			open: false,
			options: options,
		};
	},
	mounted() {
		this.open = true;
	},
	computed: {
		auctionDate() {
			var date = new Date(this.auction.bidding_starts_at);
			return (
				padTo2Digits(date.getDate()) +
				"." +
				padTo2Digits(date.getMonth() + 1) +
				"." +
				date.getFullYear()
			);
		},
		auctionTimeStart() {
			var date = new Date(this.auction.bidding_starts_at);
			return (
				padTo2Digits(date.getHours()) + ":" + padTo2Digits(date.getMinutes())
			);
		},
		auctionTimeEnd() {
			var date = new Date(this.auction.bidding_ends_at);
			return (
				padTo2Digits(date.getHours()) + ":" + padTo2Digits(date.getMinutes())
			);
		},
	},
	methods: {
		close() {
			//this.$emit('close');
			let ref = this.$refs.overlay,
				that = this;
			setTimeout(function () {
				that.$emit("close");
			}, 300);
			this.$nextTick(function () {
				this.open = false;
			});
		},
		async submit() {
			let endpoint = this.$route("offers_sell.editInline", {
					id: this.offer.id,
				}),
				that = this;
			this.form.patch(endpoint, {
				onSuccess(p) {
					that.close();
					that.setShowAuctionSubmittedModal();
					console.log("form submit success");
				},
				onError(e) {
					console.log("form submit error");
				},
			});
		},
		getLabel(what, where) {
			return options.getLabel(what, where);
		},
		maybeStrikethrough(ref, now, suffix = "") {
			if (ref == null || ref == "") {
				return "";
			} else if (ref == now) {
				return "";
			} else {
				return `<span class="line-through text-red-600">${ref} ${suffix}</span>`;
			}
		},
		setShowAuctionSubmittedModal() {
			let submittedModal = this.showAuctionSubmittedModal;
			submittedModal = true;
			this.$emit("set-submitted-modal", submittedModal);
		},
	},
};
</script>
